import React, { useState, useEffect, RefObject, useMemo } from "react";

import "./index.less"; // 引入 Less 样式
import { elementDesc, InOutStreams } from "@/config/dataMap";
import TowerPage from "./ElementPages/Tower";
import PumpPage from "./ElementPages/Pump";
import HeatExchangerPage from "./ElementPages/HeatExchanger";
import MixerPage from "./ElementPages/Mixer";
import SplitterPage from "./ElementPages/Splitter";

interface ProcessComponentProps {
    input: any;
    transInput: any;
    results: any;
    selectTreeButton: any;
    scrollViewRef: RefObject<HTMLDivElement>;
}

// 常量定义
const towerResultPages = ["工艺计算结果", "水力学计算"];
const commonResultPages = ["流股工艺数据", "流股组分数据"];

const ProcessComponent = ({
    input,
    transInput,
    results,
    selectTreeButton,
    scrollViewRef,
}: ProcessComponentProps) => {
    const [selectResultPage, setSelectResultPage] = useState(towerResultPages[0]);
    const [elementTabs, setElementTabs] = useState<any>(towerResultPages);

    const InOutStreams = useMemo(() => {
  // 如果没有数据直接返回空对象
  if (!input?.inputs?.elements) return {};
  const result: Record<string, { in: string[], out: string[] }> = {};
  // 遍历所有设备单元
        input.inputs.elements.forEach((unit: any) => {
            const unitName = unit.name; // 设备名 B1 / P-109 等
    if (!unitName) return;
    // 提取输入流股名称
    const inStreams = unit.inputStreams?.map((stream: any) => stream.name) || [];
    // 提取输出流股名称
    const outStreams = unit.outputStreams?.map((stream: any) => stream.name) || [];
    result[unitName] = {
      in: inStreams,
      out: outStreams,
    };
  });
  return result;
}, [input]); // 依赖项：input 变化时才重新计算
    // 根据选中的设备类型切换标签页
    useEffect(() => {
        if (
            selectTreeButton.type === "DistilStrict"
        ) {
            setElementTabs(towerResultPages);
            setSelectResultPage(towerResultPages[0]);
        } else {
            setElementTabs(commonResultPages);
            setSelectResultPage(commonResultPages[0]);
        }
    }, [selectTreeButton]);

    // 构建流股数据源
    const buildSource = (elementName: string) => {
        if (!results) return { inputStreams: [], outStreams: [] };

        const { elements, streams } = results;
        // const InOutStreams = generateInOutStreams();
        const s = InOutStreams[elementName] || { in: [], out: [] };
        const inputStreams = s.in.map((i: string) => streams.find((s: any) => s.name === i));
        const outStreams = s.out.map((i: string) => streams.find((s: any) => s.name === i));

        return { inputStreams, outStreams };
    };

    // 根据选中的设备渲染对应页面
    // const showElementPage = () => {
    //     switch (selectTreeButton.type) {
    //         // 塔设备
    //         case "DistilStrict":
    //             return (
    //                 <TowerPage
    //                     input={input}
    //                     transInput={transInput}
    //                     results={results}
    //                     selectTreeButton={selectTreeButton.name}
    //                     scrollViewRef={scrollViewRef}
    //                     selectResultPage={selectResultPage}
    //                 />
    //             );
    //         // 泵设备
    //         case "Pump":
    //             return (
    //                 <PumpPage
    //                     input={input}
    //                     transInput={transInput}
    //                     results={buildSource(selectTreeButton.name)}
    //                     selectTreeButton={selectTreeButton.name}
    //                     selectResultPage={selectResultPage}
    //                 />
    //             );
    //         // 分流器
    //         case "Splitter":
    //             return (
    //                 <SplitterPage
    //                     input={input}
    //                     transInput={transInput}
    //                     results={buildSource(selectTreeButton.name)}
    //                     selectTreeButton={selectTreeButton.name}
    //                     selectResultPage={selectResultPage}
    //                 />
    //             );
    //         // 换热器
    //         case "ShellAndTubeExchanger":
    //             return (
    //                 <HeatExchangerPage
    //                     input={input}
    //                     transInput={transInput}
    //                     results={buildSource(selectTreeButton.name)}
    //                     selectTreeButton={selectTreeButton.name}
    //                     selectResultPage={selectResultPage}
    //                 />
    //             );
    //         // 混合器
    //         case "Mixer":
    //             return (
    //                 <MixerPage
    //                     input={input}
    //                     transInput={transInput}
    //                     results={buildSource(selectTreeButton.name)}
    //                     selectTreeButton={selectTreeButton.name}
    //                     selectResultPage={selectResultPage}
    //                 />
    //             );
    //         default:
    //             return null;
    //     }
    // };
    const showElementPage = () => {
        if (selectTreeButton.type === "DistilStrict") {
            return (
                // 塔设备
                <TowerPage
                    input={input}
                    transInput={transInput}
                    results={results}
                    selectTreeButton={selectTreeButton.name}
                    scrollViewRef={scrollViewRef}
                    selectResultPage={selectResultPage}
                />
            )
        } else {
            return (
                <MixerPage
                    input={input}
                    transInput={transInput}
                    results={buildSource(selectTreeButton.name)}
                    selectTreeButton={selectTreeButton.name}
                    selectResultPage={selectResultPage}
                />)
        }
    };

    return (
        <div className="process-component-container">
            {/* 结果头部（设备名称 + 标签页） */}
            <div className="result-header-container">
                <div className="result-header">
                    <span className="device-name-text">
                        {elementDesc[selectTreeButton.name]
                            ? `${selectTreeButton.name} (${elementDesc[selectTreeButton.name]})`
                            : selectTreeButton.name}
                        ：
                    </span>
                </div>
                <div className="result-page-list">
                    {elementTabs.map((item: string, index: number) => (
                        <button
                            key={index}
                            className={`result-tab-btn ${item === selectResultPage ? "active" : ""
                                }`}
                            onClick={() => setSelectResultPage(item)}
                        >
                            <span
                                className={`result-tab-text ${item === selectResultPage ? "active" : ""
                                    }`}
                            >
                                {item}
                            </span>
                        </button>
                    ))}
                </div>
            </div>

            {/* 设备详情页面 */}
            <div className="element-page-content">
                {showElementPage()}
            </div>
        </div>
    );
};

export default ProcessComponent;